export default __webpack_public_path__ + "static/media/Luunox_blanco_(300x263).9498a3c2.png";